var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2716 40.9087C32.8398 41.5114 32.8398 42.4888 32.2716 43.0915C31.7032 43.6942 30.7818 43.6942 30.2136 43.0915L25.9708 38.5915C25.4026 37.9888 25.4026 37.0114 25.9708 36.4087L30.2136 31.9087C30.7818 31.3058 31.7032 31.3058 32.2714 31.9087C32.8398 32.5114 32.8398 33.4888 32.2716 34.0915L29.0578 37.5001L32.2716 40.9087ZM36.2136 34.0915C35.6452 33.4888 35.6452 32.5115 36.2136 31.9087C36.7818 31.306 37.7032 31.306 38.2716 31.9087L42.5142 36.4087C43.0824 37.0115 43.0824 37.9888 42.5142 38.5915L38.2716 43.0915C37.7032 43.6943 36.7818 43.6943 36.2136 43.0915C35.6452 42.4888 35.6452 41.5114 36.2136 40.9087L39.4272 37.5001L36.2136 34.0915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9C10.5 6.51471 12.5147 4.5 15 4.5H33C35.4853 4.5 37.5 6.51472 37.5 9V27C37.5 27.8284 36.8284 28.5 36 28.5H29.7426C29.3448 28.5 28.9634 28.6581 28.6819 28.9394L22.0896 35.5317C21.6332 35.9883 21.5199 36.6856 21.8086 37.2631L23.8416 41.3292C24.0741 41.7942 24.0494 42.3463 23.7761 42.7886C23.5026 43.2308 23.0199 43.5 22.5 43.5H15C12.5147 43.5 10.5 41.4854 10.5 39V9ZM19.5 7.5C18.6715 7.5 18 8.17158 18 9C18 9.82842 18.6715 10.5 19.5 10.5H28.5C29.3284 10.5 30 9.82842 30 9C30 8.17158 29.3284 7.5 28.5 7.5H19.5Z",
    fill: "url(#paint0_linear_1_267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_267",
    x1: 29.8642,
    y1: 13.2894,
    x2: 11.1471,
    y2: 29.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490049,
    stopColor: "#FA7C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8CED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.75761b195133cbde7a86913b8f429bd6.svg";
export { ForwardRef as ReactComponent };